import { useMutation, useQueryClient } from 'react-query'
import { useSnackbar } from 'notistack'
import { deleteUserSetting } from 'services/cm-api/delete-user-setting'

export function useDeleteUserSettings() {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(deleteUserSetting, {
    onMutate: async ({ tableName, key }) => {
      // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
      await queryClient.cancelQueries('getSettingsStructure')
      // Snapshot the previous value
      const previousSettings = queryClient.getQueryData('getSettingsStructure')

      // Return a context object with the snapshotted value
      return { previousSettings }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries('getSettingsStructure')
      enqueueSnackbar('Setting is deleted', { variant: 'success' })
    },
    onError: (err) => {
      enqueueSnackbar('Failed to delete', { variant: 'error' })
      console.error('Deletion failed: ', err)
    },
  })
}
